import { FC, useState, useEffect } from 'react';
import EventCard from './EventCard';

interface Event {
	id: number;
	title: string;
	date: string;
	description: string;
	images: { [key: string]: string };

}

interface CardsViewProps {
	events: Event[];
	eventsPerPage: number;
	onEventClick: (event: Event) => void;
}

const CardsView: FC<CardsViewProps> = ({ events, eventsPerPage, onEventClick }) => {
	// State to keep track of the number of events currently displayed
	const [displayedEvents, setDisplayedEvents] = useState<Event[]>([]);

	// State to track if there are more events to load
	const [hasMoreEvents, setHasMoreEvents] = useState<boolean>(false);

	useEffect(() => {
		// Initialize displayedEvents when events prop changes
		setDisplayedEvents(events.slice(0, eventsPerPage));
		setHasMoreEvents(events.length > eventsPerPage);
	}, [events, eventsPerPage]);

	const handleLoadMore = () => {
		const newDisplayedEvents = events.slice(0, displayedEvents.length + eventsPerPage);
		setDisplayedEvents(newDisplayedEvents);
		setHasMoreEvents(newDisplayedEvents.length < events.length);
	};

	return (
		<div>
			{displayedEvents.length === 0 ? (
				<p>No events this month</p>
			) : (
				<div className={"fsdpe-calendar-wrapper__views__cards"}
				>
					{displayedEvents.map((event) => (
						<EventCard key={event.id} event={event} onClick={() => onEventClick(event)} />
					))}
				</div>
			)}
			{hasMoreEvents && (
				<button
					className={"fsdpe-calendar-wrapper__btn"}
					style={{
					display:'block',
					marginLeft:'auto',
					marginRight:'auto',
					marginTop:'32px'
					}}
						onClick={handleLoadMore}>
					Load More
				</button>
			)}
		</div>
	);
};

export default CardsView;
